import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import { Grid, Row, Col } from 'react-flexbox-grid';

const InfoDebtorH = ({ t }) => {
  return (
    <Grid className="info">
      <Row center="xs">
        <Col xs={12}>
          <h2>{t('Potrebujete poradiť?')}</h2>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <h3>{t('Prehľadný popis krokov pri Registrácii do systému a pri Žiadosti o pôžičku')}</h3>
          <ol className="numbered">
            <li>
              {t(
                'Odoslanie predbežnej Žiadosti o pôžičku spolu s Registráciou na portáli www.majak.sk.'
              )}
            </li>
            <li>
              {t(
                'Overenie e-mailovej adresy. Na e-mailovú adresu Vám budú zasielané všetky dôležité informácie a pokyny ohľadom ďalšieho postupu ako aj všetky zmluvné dokumenty.'
              )}
            </li>
            <li>
              {t(
                'Nahratie prednej a zadnej strany občianskeho preukazu do Systému kvôli overeniu Vašej identity.'
              )}
            </li>
            <li>
              {t(
                'Zo strany www.majak.sk dôjde k prevereniu Vašich osobných dokladov (občiansky preukaz, príp. iné doklady) a schváleniu / neschváleniu Vašej identity.'
              )}
            </li>
            <li>
              {t(
                'Po schválení Vašej identity nasleduje elektronické podpísanie Rámcovej zmluvy so spoločnosťou Peer2Peer, s.r.o. (prevádzkovateľom portálu www.majak.sk) pre plné využívanie služieb portálu www.majak.sk'
              )}
              <p style={{ margin: '15px 0 15px -15px' }}>
                {t(
                  'Od tohto momentu ste sa úspešne zaregistrovali a otvorili si konto na www.majak.sk. Odteraz môžete zadávať Vaše ľubovoľné Žiadosti o pôžičku so želanými podmienkami, pre ktoré bude portál www.majak.sk hľadať vhodných investorov.'
                )}
              </p>
            </li>
            <li>{t('Elektronické podpísanie záväznej Žiadosti o pôžičku a jej odoslanie.')}</li>
            <li>
              {t(
                'Opätovné potvrdenie a podpísanie Rámcovej zmluvy a záväznej Žiadosti o pôžičku formou zadania SMS kódu do Systému www.majak.sk. SMS kód dôjde na Váš mobilný telefón, ktorý ste si zadali pri registrácii.'
              )}
            </li>
            <li>
              {t(
                'Po schválení / zamietnutie Vašej záväznej Žiadosti o pôžičku nasleduje zaradenie do interného Systému hľadania vhodných investorov do Vašej pôžičky. Portál www.majak.sk pre Vás následne usilovne hľadá investora /ov do Vašej pôžičky.'
              )}
            </li>
            <li>{t('Úspešné nájdenie investora do Vašej pôžičky.')}</li>
            <li>{t('Odoslanie peňazí na Váš účet.')}</li>
          </ol>
        </Col>
        <Col xs={12} md={6}>
          <h3>{t('Ako to funguje?')}</h3>
          <p>
            {t(
              'Ide o moderné informačné riešenie umožňujúce stretnutie dlžníka a investora. Základný princíp je v požičiavaní peňazí od investorov, ktorí ich majú navyše, k dlžníkom, ktorým peniaze naopak chýbajú, pričom jeden investor môže požičať peniaze naraz niekoľkým dlžníkom, čím sa výrazne zníži riziko nesplatenia úveru. Ide o komunitné investovanie alebo kolektívne požičiavanie v rámci ktorého vystupujú spravidla tri subjekty:'
            )}
          </p>
          <ul className="disc">
            <li>{t('dlžník, ktorý si požičiava,')}</li>
            <li>{t('veriteľ (investor), ktorý poskytuje finančné prostriedky dlžníkovi,')}</li>
            <li>{t('internetová platforma, kde sa títo dvaja nájdu.')}</li>
          </ul>
          <h3>{t('Čo ak chcem predčasne splatiť pôžičku?')}</h3>
          <p>
            {t(
              'Stačí poslať žiadosť najneskôr 7 pracovných dní pred dňom predčasného splatenia. My Vám pošleme k tomuto dňu presnú sumu akú je potrebné splatiť. Za predčasné splatenie splátky sa viaže poplatok podľa'
            )}{' '}
            <Link to="/cennik">{t('cenníka')}</Link>.
          </p>
          <h3>{t('Kto si môže požičať?')}</h3>
          <p>
            {t(
              'O pôžičku môže požiadať každý, kto má 18 a viac rokov, má občianstvo SR a úspešne splnil podmienky skóringu.'
            )}
          </p>
        </Col>
      </Row>
    </Grid>
  );
};

InfoDebtorH.propTypes = {
  t: PropTypes.func.isRequired,
};

export const InfoDebtor = translate()(InfoDebtorH);

const InfoCreditorH = ({ t }) => {
  return (
    <Grid className="info">
      <Row center="xs">
        <Col xs={12}>
          <h2 >{t('Potrebujete poradiť?')}</h2>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <h3>{t('Ako to funguje?')}</h3>
          <p>
            {t(
              'Ide o moderné informačné riešenie umožňujúce stretnutie dlžníka a investora. Základný princíp je v požičiavaní peňazí od investorov, ktorí ich majú navyše, k dlžníkom, ktorým peniaze naopak chýbajú, pričom jeden investor môže požičať peniaze naraz niekoľkým dlžníkom, čím sa výrazne zníži riziko nesplatenia úveru. Ide o komunitné investovanie alebo kolektívne požičiavanie v rámci ktorého vystupujú spravidla tri subjekty:'
            )}
          </p>
          <ul className="disc">
            <li>{t('dlžník, ktorý si požičiava,')}</li>
            <li>{t('veriteľ (investor), ktorý poskytuje finančné prostriedky dlžníkovi,')}</li>
            <li>{t('internetová platforma, kde sa títo dvaja nájdu.')}</li>
          </ul>
        </Col>
        <Col xs={12} md={6}>
          <h3>{t('Ako je zabezpečená moja investícia?')}</h3>
          <p>
            {t(
              'Vaša investícia je zabezpečená hneď tri krát. Cez skóringový model dlžníka, rozložením rizika na viac dlžníkov a garanciou preplatenia nesplatenej časti istiny.'
            )}
          </p>
          <h3>{t('Kto môže investovať?')}</h3>
          <p>{t('Investovať môže každý, kto má 18 a viac rokov a má občianstvo SR.')}</p>
        </Col>
      </Row>
    </Grid>
  );
};

InfoCreditorH.propTypes = {
  t: PropTypes.func.isRequired,
};

export const InfoCreditor = translate()(InfoCreditorH);



// WEBPACK FOOTER //
// ./src/features/calculator/components/partials.js